import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create course
export const createEnrollment = data => post(url.CREATE_ENROLLMENT, data);
export const updateEnrollment = data => put(url.UPDATE_ENROLLMENT, data);
export const deleteEnrollment = id => del(url.DELETE_ENROLLMENT + id);
export const fetchAllEnrollmentsOfCourse = id => get(url.FETCH_ALL_ENROLLMENTS_OF_COURSE + id);
export const fetchSingleEnrollment = id => get(url.FETCH_SINGLE_ENROLLMENT + id);